/* eslint-disable camelcase */
import safeJSONParse from '@src/utils/safeJSONParse';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import RenderMarkdown from '../RTEditor/RenderMarkdown';
import './ChatbotHistoryViewer.css';

type ChatbotHistoryViewerProps = {
  timeZoneName: string;
  jsonChatbotHistory: string;
};

type ChatbotHistoryItem = {
  message_id: string;
  text: string;
  datetime: number;
  from: {
    full_name: string;
    is_bot: boolean;
  };
  to: {
    full_name: string;
    is_bot: boolean;
  };
};

const ChatbotHistoryViewer: React.FC<ChatbotHistoryViewerProps> = ({
  jsonChatbotHistory,
}) => {
  const chatbotHistory = useMemo(
    () => safeJSONParse<ChatbotHistoryItem[]>(jsonChatbotHistory),
    [jsonChatbotHistory]
  );

  if (!chatbotHistory || !Array.isArray(chatbotHistory)) return null;

  return (
    <div style={{ paddingTop: '0.1em' }}>
      {chatbotHistory.map(item => (
        <div
          key={item.message_id}
          className={`ChatbotMsgBox ${
            item.from?.is_bot ? 'ChatbotMsgBoxFromBot' : 'ChatbotMsgBoxFromUser'
          }`}
        >
          {item.datetime && (
            <div className="TimeRow">
              {dayjs(item.datetime).format('DD MMM YYYY - hh:mm a')}
            </div>
          )}

          <RenderMarkdown markdown={item.text} />
        </div>
      ))}
    </div>
  );
};

export default ChatbotHistoryViewer;
